import { useContext } from "react";

import type { CatalogSearchData } from "@shared/components/CatalogSearch/CatalogSearchContext";
import { CatalogSearchContext } from "@shared/components/CatalogSearch/CatalogSearchContext";

const useCatalogSearch = (): CatalogSearchData => {
  return useContext(CatalogSearchContext);
};

export { useCatalogSearch };
